module.exports = __webpack_public_path__ + "img/groups_jobmule.0f546ace.png";